import React from 'react';
import { Chip, styled } from "@mui/material";

const SummaryChip = styled(Chip)(({theme}) => ({
    width: '75px',
    height: 'auto',
    padding: '3px 0px',
    borderRadius: '4px',
    backgroundColor: theme.palette.button.primary,
    color: '#FFF',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 400,
    '& .MuiChip-label': {
        padding: 0,
    },
    '&:hover': {
        backgroundColor: theme.palette.button.primary,
        backgroundImage: 'linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%) !important',
    }
}));

const ProcessingLabelChip = styled(Chip)(() => ({
    height: 'auto',
    padding: '3px 12px',
    borderRadius: '4px',
    backgroundColor: 'rgba(36, 167, 224, 0.15)',
    color: '#1479BB',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 400,
    '& .MuiChip-label': {
        padding: 0,
    },
}));

const NoPayerChip = styled(Chip)(() => ({
    height: 'auto',
    padding: '3px 12px',
    borderRadius: '4px',
    backgroundColor: '#cfd8dc',
    color: '#424242',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 400,
    '& .MuiChip-label': {
        padding: 0,
    },
}));

function Chips({ type, onClick }) {
    return (
        <React.Fragment>
            {type === 'summary' && (
                <SummaryChip 
                    label="View" 
                    clickable 
                    onClick={onClick} 
                />
            )}
            {type === 'processing' && (
                <ProcessingLabelChip 
                    label="Processing" 
                />
            )}
            {type === 'noPayer' && (
                <NoPayerChip 
                    label="No Payer Data" 
                />
            )}
        </React.Fragment>
    );
}

export default Chips;